"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IMAGE_SELECTOR = '[data-parallax-image]';

var parallax = exports.parallax = function parallax(container, factors) {

  var images = container.find(IMAGE_SELECTOR);
  var lastTop = void 0;

  if (!factors || factors.length < images.length) {
    factors = images.map(function (image, i) {
      return factors && factors[i] || -0.2;
    });
  }

  updateParallax();

  function updateParallax() {
    var rect = container[0].getBoundingClientRect();
    var top = rect.top;

    if (top != lastTop) {
      var sTop = $(window).scrollTop();
      var eBottom = rect.bottom;
      var containerTop = container.offset().top;

      //Is  section in view?
      var visible = top < window.innerHeight && eBottom >= 0;

      if (visible) {
        var percent = (sTop + rect.height - containerTop) / rect.height * 100;

        images.each(function (i, e) {
          var self = $(e);
          self.css({
            "transform": "translateY(" + (percent * factors[i]).toFixed(1) + "%)",
            "-webkit-transform": "translateY(" + (percent * factors[i]).toFixed(1) + "%)"
          });
        });
      }
    }

    lastTop = top;
    requestAnimationFrame(function () {
      return updateParallax();
    });
  }
};